import { useMemo } from "react";
import { useQuery } from "@apollo/client";

import { SEARCH_SPACELIFT_VCS_REPO_REVISIONS_SUGGESTIONS } from "./gql";

type UseSearchSpaceliftVcsRepoRevisionsSuggestionsProps = {
  repoId: string | undefined;
};

const useSearchSpaceliftVcsRepoRevisionsSuggestions = ({
  repoId,
}: UseSearchSpaceliftVcsRepoRevisionsSuggestionsProps) => {
  const { data, error, loading, previousData } = useQuery(
    SEARCH_SPACELIFT_VCS_REPO_REVISIONS_SUGGESTIONS,
    {
      variables: {
        repoID: repoId || "",
        input: {
          fullTextSearch: null,
          predicates: null,
          fields: null,
        },
      },
      skip: !repoId,
    }
  );

  const cachedSuggestions = useMemo(() => {
    return (
      data?.searchRevisionsSuggestions?.fields ||
      previousData?.searchRevisionsSuggestions?.fields ||
      []
    );
  }, [data, previousData]);

  const filteredCount = useMemo(() => {
    return (
      data?.searchRevisionsSuggestions?.filteredCount ||
      previousData?.searchRevisionsSuggestions?.filteredCount ||
      0
    );
  }, [data, previousData]);

  return {
    cachedSuggestions,
    filteredCount,
    loading,
    error,
  };
};

export default useSearchSpaceliftVcsRepoRevisionsSuggestions;
